(function () {
  const roots = document.querySelectorAll('[data-vp-smart-box-builder]');
  if (!roots.length) return;

  const COPY = {
    en: {
      labels: {
        love: 'You will love it',
        like: 'You will like it',
        adventure: 'New adventures',
        manual: 'Manually added'
      },
      reasons: {
        love: 'Close to wines you loved.',
        like: 'Similar to wines you liked.',
        adventure: 'A safe adventure inside your taste zone.',
        manual: 'Added by you.'
      },
      reasonBecauseLoved: 'Because you loved {wine}.',
      reasonBecauseLiked: 'Because you liked {wine}.',
      noAlternative: 'No other match available for this taste.',
      preparing: 'Preparing your Smart Box...',
      updating: 'Updating your box...',
      profileNeeded: 'Your Smart Box needs your taste profile first. Start with the Test Kit or log in to use your recommendations.',
      notEnoughRatings: 'Rate your Test Kit wines to build your Smart Box.',
      notEnoughRatingsHint: 'As soon as you rate a wine, we match it against our lab and fill your box with the closest bottles in stock.',
      missingPreference: 'Not enough wines match this setup yet.',
      missingPreferenceHint: 'In the table below, adjust Wine type or switch to Like it / Safe adventure. You can also use Add specific wines.',
      quantity: 'Quantity',
      decreaseQuantity: 'Decrease quantity',
      increaseQuantity: 'Increase quantity',
      wineType: 'Wine type',
      redWine: 'Red wine',
      whiteWine: 'White wine',
      loveQuestion: 'How much I will love it',
      safeAdventure: 'Safe adventure',
      remove: 'Remove',
      replace: 'Replace',
      generatedPlaceholder: 'Your generated wines will appear here.',
      country: 'Country',
      notFound: 'We could not find that wine. Try another name from the list.',
      chooseWineFirst: 'Please choose a wine from the list before adding.',
      duplicateWine: 'This wine is already in your box. Every bottle stays unique.',
      minimumBottles: 'Your Smart Box needs at least 3 bottles.',
      addedToCart: 'Your Smart Box is ready. Opening checkout...',
      bottle: 'bottle',
      bottles: 'bottles',
      minimumRequired: 'Minimum 3 bottles required',
      minimumShort: 'Minimum 3 bottles',
      addAtLeast: 'Add at least',
      order: 'Order my Smart Wine Box',
      free: 'Free',
      freeFirstBox: 'Free shipping on your first Smart Box - Fast delivery (48-72h)',
      freeShipping: 'Free shipping',
      freeShippingUnlocked: 'Free shipping unlocked.',
      bottlesUntilFreeShipping: 'Add {count} more {unit} for free shipping.',
      shippingTo: 'Shipping to',
      forText: 'for',
      fastDelivery: 'Fast delivery (48-72h)',
      alreadyPurchased: 'Already purchased',
      availableWine: 'Available wine',
      redType: 'Red wine',
      whiteType: 'White wine',
      demoMeasuring: 'Measuring lab distance...',
      demoHeadlineDefault: 'An example box, built from 3 wines - exactly like a Test Kit',
      demoHeadlineNamed: 'Built around {wine}',
      demoReason: '{score}% lab similarity to {wine}.',
      demoSeedReason: 'One of the 3 wines this box is built from.',
      demoRebuild: 'Rebuild the box',
      demoFailed: 'The lab engine is unreachable right now. It is what builds your box once you have rated your Test Kit wines.'
    },
    nl: {
      labels: {
        love: 'Hier ga je van houden',
        like: 'Deze ga je lekker vinden',
        adventure: 'Nieuwe avonturen',
        manual: 'Handmatig toegevoegd'
      },
      reasons: {
        love: 'Dicht bij wijnen waar je van hield.',
        like: 'Vergelijkbaar met wijnen die je lekker vond.',
        adventure: 'Een nieuw avontuur binnen jouw smaakprofiel.',
        manual: 'Door jou toegevoegd.'
      },
      reasonBecauseLoved: 'Omdat je van {wine} hield.',
      reasonBecauseLiked: 'Omdat je {wine} lekker vond.',
      noAlternative: 'Geen ander alternatief voor deze smaak.',
      preparing: 'Je Smart Box wordt voorbereid...',
      updating: 'Je box wordt bijgewerkt...',
      profileNeeded: 'Je Smart Box heeft eerst je smaakprofiel nodig. Start met de Test Kit of log in om je aanbevelingen te gebruiken.',
      notEnoughRatings: 'Beoordeel je Test Kit-wijnen om je Smart Box te bouwen.',
      notEnoughRatingsHint: 'Zodra je een wijn beoordeelt, matchen we die in ons lab en vullen we je box met de dichtstbijzijnde flessen op voorraad.',
      missingPreference: 'Er zijn nu te weinig wijnen die bij deze instelling passen.',
      missingPreferenceHint: 'Pas in de tabel hieronder de wijnsoort aan of kies Like it / Nieuwe avonturen. Je kunt ook specifieke wijnen toevoegen.',
      quantity: 'Aantal',
      decreaseQuantity: 'Aantal verlagen',
      increaseQuantity: 'Aantal verhogen',
      wineType: 'Wijnsoort',
      redWine: 'Rode wijn',
      whiteWine: 'Witte wijn',
      loveQuestion: 'Hoe goed past deze wijn bij mij?',
      safeAdventure: 'Nieuwe avonturen',
      remove: 'Verwijderen',
      replace: 'Vervangen',
      generatedPlaceholder: 'Je geselecteerde wijnen verschijnen hier.',
      country: 'Land',
      notFound: 'We konden die wijn niet vinden. Probeer een andere naam uit de lijst.',
      chooseWineFirst: 'Kies eerst een wijn uit de lijst voordat je toevoegt.',
      duplicateWine: 'Deze wijn zit al in je box. Elke fles blijft uniek.',
      minimumBottles: 'Je Smart Box heeft minstens 3 flessen nodig.',
      addedToCart: 'Je Smart Box staat klaar. We openen de checkout...',
      bottle: 'fles',
      bottles: 'flessen',
      minimumRequired: 'Minimaal 3 flessen nodig',
      minimumShort: 'Minimaal 3 flessen',
      addAtLeast: 'Voeg nog toe:',
      order: 'Bestel mijn Smart Wine Box',
      free: 'Gratis',
      freeFirstBox: 'Gratis verzending op je eerste Smart Box - snelle levering (48-72u)',
      freeShipping: 'Gratis verzending',
      freeShippingUnlocked: 'Gratis verzending ontgrendeld.',
      bottlesUntilFreeShipping: 'Voeg nog {count} {unit} toe voor gratis verzending.',
      shippingTo: 'Verzending naar',
      forText: 'voor',
      fastDelivery: 'Snelle levering (48-72u)',
      alreadyPurchased: 'Al gekocht',
      availableWine: 'Beschikbare wijn',
      redType: 'Rode wijn',
      whiteType: 'Witte wijn',
      demoMeasuring: 'Lab-afstand meten...',
      demoHeadlineDefault: 'Een voorbeeldbox, gebouwd op 3 wijnen - precies zoals een Test Kit',
      demoHeadlineNamed: 'Gebouwd rond {wine}',
      demoReason: '{score}% lab-gelijkenis met {wine}.',
      demoSeedReason: 'Een van de 3 wijnen waarop deze box is gebouwd.',
      demoRebuild: 'Herbouw de box',
      demoFailed: 'De lab-motor is nu niet bereikbaar. Dit is wat je box bouwt zodra je je Test Kit-wijnen hebt beoordeeld.'
    }
  };

  // Match levels from closest to widest. Drives the cascade order (love before
  // like before adventure) when filling and grouping the box.
  const LEVEL_RANK = { love: 0, like: 1, adventure: 2 };

  const DEFAULT_ROWS = {
    mix: [
      { quantity: 1, wineType: 'red', match: 'love' },
      { quantity: 2, wineType: 'white', match: 'love' },
      { quantity: 3, wineType: 'white', match: 'like' }
    ],
    red: [
      { quantity: 3, wineType: 'red', match: 'love' },
      { quantity: 3, wineType: 'red', match: 'like' }
    ],
    white: [
      { quantity: 3, wineType: 'white', match: 'love' },
      { quantity: 3, wineType: 'white', match: 'like' }
    ]
  };

  roots.forEach(initBuilder);

  function initBuilder(root) {
    const catalog = readCatalog(root);
    const customerId = getCustomerId(root);
    const state = {
      color: 'mix',
      rows: cloneRows(DEFAULT_ROWS.mix),
      catalog,
      // id -> title for the wines a customer could have rated (Test Kit / blind
      // tasting), used to name the reason a wine is recommended. Those bottles are
      // usually not in the sellable catalog, so this fills that gap.
      titleMap: readTitleMap(root),
      selected: [],
      // Specific wines the customer picked by name. Kept separate from the auto
      // preference rows so they survive every regenerate, and are appended to the
      // box (and shown as their own rows at the end of the table).
      manualRows: [],
      ratings: [],
      distanceRows: [],
      loveIds: new Set(),
      likeIds: new Set(),
      ownedIds: new Set(),
      scores: null,
      loading: false,
      generateTimer: null,
      demoTimer: null
    };

    populateSearchOptions(root, catalog);
    bindEvents(root, state);
    bindQuantityControls(root, state);
    bindManualAddButtonState(root, state);
    renderPreferences(root, state);
    updateTabs(root, state);
    updateSummary(root, state);

    if (!customerId) {
      startDemo(root, state, 'anonymous');
      // Customers land here, build an example box, then reach a locked order
      // card and do not understand they must log in first. Nudge with a popup
      // immediately, but only once per browser session so it does not nag on
      // every page view.
      if (!sessionStorage.getItem('vpSmartBoxLoginPromptShown')) {
        sessionStorage.setItem('vpSmartBoxLoginPromptShown', 'true');
        showLoginModal(root);
      }
      return;
    }

    setMode(root, 'member');
    loadTasteProfile(root, state, customerId).then((outcome) => {
      // A logged-in customer never sees the example box (that is anonymous-only).
      // We build a full box from their real ratings, cascading love -> like ->
      // adventure to fill it with whatever is available, never their own wines.
      if (outcome === 'error') return; // profileNeeded message already shown
      // Start on the colour they actually have wines for (a red-only profile
      // should not open on a mix preset that leaves white rows empty).
      state.color = pickStartColor(state);
      state.rows = buildAllocatedRows(state, state.color);
      renderPreferences(root, state);
      updateTabs(root, state);
      generateBox(root, state);
    });
  }

  function readCatalog(root) {
    const script = root.querySelector('[data-vp-smart-box-catalog]');
    if (!script) return [];
    const purchasedIds = getPurchasedProductIds();
    try {
      return JSON.parse(script.textContent || '[]')
        .filter((product) => product && product.variantId && product.available)
        .map((product) => ({
          ...product,
          id: String(product.id),
          variantId: Number(product.variantId),
          price: Number(product.price || 0),
          purchased: purchasedIds.has(String(product.id))
        }));
    } catch (error) {
      console.error('Smart Box catalog parse failed', error);
      return [];
    }
  }

  // id -> title for wines a customer could have rated (Test Kit / blind tasting),
  // emitted by the Liquid snippet. Keys are stringified so lookups by id are safe.
  function readTitleMap(root) {
    const script = root.querySelector('[data-vp-smart-box-titles]');
    if (!script) return {};
    try {
      const raw = JSON.parse(script.textContent || '{}');
      const map = {};
      Object.keys(raw).forEach((id) => {
        const title = raw[id];
        if (title) map[String(id)] = String(title);
      });
      return map;
    } catch (error) {
      console.error('Smart Box titles parse failed', error);
      return {};
    }
  }

  // Merge the whole storefront product feed into state.titleMap so any rated wine
  // can be named, whatever collection it lives in. Same source the account page
  // uses (products.json), paginated until a short page ends it. Best-effort: on
  // failure the reasons simply fall back to their generic text.
  async function loadProductTitles(state) {
    try {
      const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      for (let page = 1; page <= 6; page += 1) {
        const response = await fetch(`${base}products.json?limit=250&page=${page}`);
        if (!response.ok) break;
        const data = await response.json();
        const products = (data && data.products) || [];
        products.forEach((product) => {
          if (product && product.id && product.title) {
            state.titleMap[String(product.id)] = String(product.title);
          }
        });
        if (products.length < 250) break;
      }
    } catch (error) {
      console.warn('Smart Box product titles feed failed', error);
    }
  }

  function bindEvents(root, state) {
    root.querySelectorAll('[data-vp-color]').forEach((button) => {
      button.addEventListener('click', () => {
        state.color = button.getAttribute('data-vp-color') || 'mix';
        // In demo the colour tabs re-seed the engine: a white seed has no red
        // neighbours, so the seed has to follow the colour the visitor asked for.
        if (getMode(root) === 'demo') {
          state.rows = cloneRows(DEFAULT_ROWS[state.color] || DEFAULT_ROWS.mix);
          state.selected = [];
          renderPreferences(root, state);
          renderSelected(root, state);
          updateTabs(root, state);
          seedDemo(root, state, pickSeedsForColor(state, state.color));
          return;
        }
        state.rows = buildAllocatedRows(state, state.color);
        state.selected = [];
        renderPreferences(root, state);
        renderSelected(root, state);
        updateTabs(root, state);
        scheduleGenerate(root, state, 0);
      });
    });

    root.querySelector('[data-vp-add-row]')?.addEventListener('click', () => {
      // Sync state.rows to the current table first, so pickSpareRow knows which
      // (type, level) combinations are already shown.
      readPreferenceRows(root, state);
      // Add a *new* preference row: a (type, level) that is not on the table yet
      // and still has a free wine. generateBox regroups by (type, level), so a
      // duplicate combination would just merge back; picking a fresh combination
      // is what makes each click add a distinct new line. Bumping the quantity of
      // an existing line is the job of that line's + control, not this button.
      const spare = pickSpareRow(state);
      if (!spare) {
        // The button should already be disabled in this case (see
        // updateAddRowButton), but never fail silently if it is clicked anyway.
        setStatus(root, t('missingPreference'), 'error');
        setAdjustHint(root, t('missingPreferenceHint'), 'error');
        return;
      }
      state.selected = [];
      state.rows.push({ quantity: 1, wineType: spare.wineType, match: spare.match });
      // Render the canonical grouped result directly (no optimistic append, no
      // debounce), so the table never shows a row that generate is about to remove.
      generateBox(root, state);
    });

    root.querySelector('[data-vp-add-manual]')?.addEventListener('click', () => addManualWine(root, state));
    root.querySelectorAll('[data-vp-add-cart]').forEach((button) => {
      button.addEventListener('click', () => addBoxToCart(root, state));
    });

    // The demo order card's "Log in to order" button had no href and no
    // handler, so anonymous visitors clicked it and nothing happened. It now
    // opens the same login popup shown automatically below.
    root.querySelectorAll('[data-vp-demo-order]').forEach((button) => {
      button.addEventListener('click', () => showLoginModal(root));
    });
    bindLoginModal(root);
  }

  // Modal is scoped to this section (see the liquid template, rendered only
  // `unless customer`), so on a member page these selectors simply find nothing.
  function bindLoginModal(root) {
    const modal = root.querySelector('[data-vp-login-modal]');
    if (!modal) return;
    modal.querySelectorAll('[data-vp-login-modal-close]').forEach((el) => {
      el.addEventListener('click', () => hideLoginModal(root));
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) hideLoginModal(root);
    });
  }

  function showLoginModal(root) {
    const modal = root.querySelector('[data-vp-login-modal]');
    if (!modal) return;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    modal.querySelector('input[name="customer[email]"]')?.focus();
  }

  function hideLoginModal(root) {
    const modal = root.querySelector('[data-vp-login-modal]');
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  function bindManualAddButtonState(root, state) {
    const input = root.querySelector('[data-vp-search-input]');
    const button = root.querySelector('[data-vp-add-manual]');
    if (!input || !button) return;

    const updateState = () => {
      const product = getExactManualProduct(state, input.value);
      button.disabled = !product;
      button.setAttribute('aria-disabled', String(!product));
    };

    root.__vpUpdateManualAddButtonState = updateState;

    input.addEventListener('input', updateState);
    input.addEventListener('change', updateState);
    input.addEventListener('blur', updateState);
    updateState();
  }

  function cloneRows(rows) {
    return rows.map((row) => ({ ...row }));
  }

  async function loadTasteProfile(root, state, customerId) {
    setStatus(root, t('preparing'), '');
    setAdjustHint(root, '', '');
    // Load the full storefront product feed in parallel with the profile. A rated
    // wine can be any product, and the Liquid title map only covers a few
    // collections, so this feed is what makes "Because you loved <wine>" reliable.
    const titlesPromise = loadProductTitles(state);
    try {
      const apiBase = getApiBase();
      const ratingsResponse = await fetch(`${apiBase}/api/ratings/getAll?customerId=${encodeURIComponent(customerId)}`, {
        headers: buildVinpopAuthHeaders(customerId)
      });
      if (!ratingsResponse.ok) {
        const detail = await readErrorDetail(ratingsResponse);
        throw new Error(detail || 'ratings_fetch_failed');
      }
      state.ratings = await ratingsResponse.json();
      state.loveIds = new Set(state.ratings.filter((item) => String(item.rating) === '3').map((item) => String(item.id)));
      state.likeIds = new Set(state.ratings.filter((item) => String(item.rating) === '2').map((item) => String(item.id)));

      // Remember the name of each wine the customer rated, so a recommendation can
      // say *why* it is there ("Because you loved Villa Loren..."). The ratings
      // payload field name is not guaranteed, so read the usual candidates.
      state.ratingTitles = {};
      state.ratings.forEach((item) => {
        const title = item.title || item.name || item.wine_name || item.wineName
          || item.product_title || item.productTitle || '';
        if (title) state.ratingTitles[String(item.id)] = String(title);
      });

      const sourceIds = [...new Set([...state.loveIds, ...state.likeIds])];
      // The customer already owns and rated these wines. Never resell them as a
      // "match": they score 100 in buildScores, so without this they surface as
      // the top "You will love it" pick, and a customer sees only his own bottles.
      state.ownedIds = new Set(sourceIds);

      if (sourceIds.length) {
        const responses = await Promise.all(sourceIds.map(async (id) => {
          const response = await fetch(`${apiBase}/api/wines/getDistance`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id })
          });
          if (!response.ok) return null;
          return {
            sourceId: id,
            sourceRating: state.loveIds.has(id) ? 'love' : 'like',
            rows: await response.json()
          };
        }));

        state.distanceRows = responses.filter(Boolean);
        state.scores = buildScores(state);
      } else {
        // Zero ratings: nothing to match. Box stays empty, ordering blocked by
        // the 3-bottle minimum, with a prompt to rate their Test Kit wines.
        state.distanceRows = [];
        state.scores = null;
      }

      // Make sure the product titles are merged in before the box renders its
      // reasons, so the very first render already knows the source wine names.
      await titlesPromise;

      setStatus(root, '', '');
      setAdjustHint(root, '', '');
      return 'ok';
    } catch (error) {
      console.error('Smart Box profile load failed', error);
      setStatus(root, t('profileNeeded'), 'error');
      setAdjustHint(root, '', '');
      return 'error';
    }
  }

  function buildScores(state) {
    const love = {};
    const like = {};
    state.loveIds.forEach((id) => addScore(love, id, 100));
    state.likeIds.forEach((id) => addScore(like, id, 100));

    state.distanceRows.forEach(({ sourceId, sourceRating, rows }) => {
      (rows || []).forEach((row) => {
        const candidateId = getComparedProductId(row, sourceId);
        const distance = Number(row.perceptive_distance || row.distance);
        if (!candidateId || !Number.isFinite(distance)) return;
        const score = Math.max(0, Math.floor(100 - distance));
        addScore(sourceRating === 'love' ? love : like, candidateId, score);
      });
    });

    return { love, like };
  }

  function addScore(map, id, score) {
    const key = String(id || '');
    if (!key || !Number.isFinite(score)) return;
    if (!map[key] || score > map[key]) map[key] = score;
  }

  function getComparedProductId(row, sourceId) {
    const source = String(sourceId);
    const id1 = String(row.productid1 || '');
    const id2 = String(row.productid2 || '');
    if (id1 === source && id2) return id2;
    if (id2 === source && id1) return id1;
    return id1 || id2;
  }

  function generateBox(root, state) {
    if (!state.scores) {
      renderSelected(root, state);
      updateSummary(root, state);
      // Logged-in member with no ratings at all: nothing to build from yet.
      if (getMode(root) === 'member') showRateMoreMessage(root, state);
      return;
    }

    state.loading = true;
    setStatus(root, t('updating'), '');
    const selected = [];
    const usedIds = new Set();
    // Reserve the manually picked wines so the auto-fill never re-selects one of
    // them (that would duplicate a bottle the customer already chose by name).
    (state.manualRows || []).forEach((manual) => usedIds.add(String(manual.productId)));

    state.rows.forEach((row, index) => {
      const quantity = Math.max(1, Number(row.quantity || 1));

      for (let bottleIndex = 0; bottleIndex < quantity; bottleIndex += 1) {
        const level = pickAvailableLevel(state, row, usedIds);
        if (!level) continue;
        const matches = findMatches(state, { wineType: row.wineType, match: level }, usedIds, []);
        if (!matches.length) continue;

        const product = matches[0];
        usedIds.add(product.id);
        // Label the wine's real level, which the cascade may have widened.
        selected.push({
          key: `${product.id}-${index}-${bottleIndex}-${Date.now()}`,
          productId: product.id,
          variantId: product.variantId,
          quantity: 1,
          label: level,
          rowIndex: 0,
          wineType: row.wineType,
          reason: getReason(level),
          product
        });
      }
    });

    // Rebuild the preference rows from the wines we actually selected, grouped by
    // (type, level). The table then always mirrors the box exactly: no phantom
    // slots, no level that the wines do not match. We keep the rows in the order
    // they were filled (i.e. the order of state.rows), so a preference the customer
    // just added stays at the bottom of the table regardless of its colour, instead
    // of being re-sorted in among the existing rows.
    const rows = [];
    const byKey = {};
    selected.forEach((item) => {
      const key = `${item.wineType}|${item.label}`;
      if (!byKey[key]) {
        byKey[key] = { wineType: item.wineType, match: item.label, quantity: 0, index: rows.length };
        rows.push(byKey[key]);
      }
      item.rowIndex = byKey[key].index;
      byKey[key].quantity += 1;
    });
    state.rows = rows.map((group) => ({ wineType: group.wineType, match: group.match, quantity: group.quantity }));

    // Append the customer's specific wines after the auto selection, so they sit
    // at the end of the box and of the preference table (they are not regrouped
    // into type/level rows: they are exact bottles the customer asked for).
    appendManualSelections(state, selected);

    state.selected = selected;
    state.loading = false;
    if (getMode(root) === 'demo') decorateDemoSelection(state);
    else decorateMemberSelection(state);
    renderPreferences(root, state);
    renderSelected(root, state);
    updateSummary(root, state);

    // Order opens as soon as we reach the 3-bottle minimum. Only warn when the
    // available wines cannot even reach it.
    if (getBottleCount(state) < 3) {
      setStatus(root, t('missingPreference'), 'error');
      setAdjustHint(root, t('missingPreferenceHint'), 'error');
    } else {
      setStatus(root, '', '');
      setAdjustHint(root, '', '');
    }
  }

  // Turn each stored manual pick into a selected box item, appended to `selected`.
  function appendManualSelections(state, selected) {
    (state.manualRows || []).forEach((manual) => {
      if (!manual || !manual.product) return;
      selected.push({
        key: `${manual.productId}-manual`,
        productId: manual.productId,
        variantId: manual.variantId,
        quantity: Math.max(1, Number(manual.quantity || 1)),
        label: 'manual',
        rowIndex: 0,
        wineType: manual.wineType,
        reason: getReason('manual'),
        product: manual.product
      });
    });
  }

  function showRateMoreMessage(root, state) {
    setStatus(root, t('notEnoughRatings').replace('{rated}', String(state.ownedIds.size)), 'error');
    setAdjustHint(root, t('notEnoughRatingsHint'), 'error');
  }

  // The level this row can actually ship. A quantity change must stay on the
  // exact level the customer selected, otherwise + on Like can silently add an
  // Adventure bottle and the table stops meaning what it says.
  function pickAvailableLevel(state, row, usedIds) {
    return findMatches(state, { wineType: row.wineType, match: row.match }, usedIds, []).length > 0 ? row.match : null;
  }

  // The single best (closest) level a wine qualifies for, or null.
  function bestLevel(state, id) {
    if (getMatchScore(state, id, 'love') !== null) return 'love';
    if (getMatchScore(state, id, 'like') !== null) return 'like';
    if (getMatchScore(state, id, 'adventure') !== null) return 'adventure';
    return null;
  }

  // Wines of the row's colour that qualify at exactly the row's level, best score
  // first. Levels are distinct wine sets (a wine belongs to one band), so rows of
  // different levels never fight over the same bottle. The shared usedIds pool
  // keeps every bottle unique across rows of the same level.
  function findMatches(state, row, usedIds, avoidedIds) {
    const avoid = new Set([...(usedIds || []), ...(avoidedIds || [])].map(String));
    return state.catalog
      .filter((product) => !avoid.has(product.id))
      .filter((product) => !product.purchased)
      .filter((product) => !state.ownedIds.has(String(product.id)))
      .filter((product) => matchesWineType(product, row.wineType))
      .filter((product) => bestLevel(state, product.id) === row.match)
      .map((product) => ({ product, score: getMatchScore(state, product.id, row.match) }))
      .sort((a, b) => b.score - a.score || a.product.title.localeCompare(b.product.title))
      .map((item) => item.product);
  }

  // Does a wine type have any usable wine at any level, given what other rows took?
  function hasAnyWine(state, wineType, excludeIds) {
    return ['love', 'like', 'adventure']
      .some((level) => findMatches(state, { wineType, match: level }, excludeIds || [], []).length > 0);
  }

  // Product ids already claimed by rows other than `index`, so per-row
  // availability and quantity caps account for the shared pool.
  function otherRowUsedIds(state, index) {
    return state.selected
      .filter((item) => item.rowIndex !== index)
      .map((item) => item.productId);
  }

  // Which wine types still have at least one usable wine for this row, given what
  // other rows already took.
  function availableWineTypes(state, index) {
    if (!state.scores) return ['red', 'white'];
    const otherUsed = otherRowUsedIds(state, index);
    return ['red', 'white'].filter((wineType) => hasAnyWine(state, wineType, otherUsed));
  }

  // How many exact-level wines this row could still take, minus what other rows
  // already claimed. This keeps + disabled when the selected level is exhausted.
  function getRowMax(state, index, row) {
    if (!state.scores) return Infinity;
    const otherUsed = otherRowUsedIds(state, index);
    const ids = new Set();
    findMatches(state, { wineType: row.wineType, match: row.match }, otherUsed, [])
      .forEach((product) => ids.add(product.id));
    return ids.size;
  }

  // Open on the colour the customer actually has wines for: a red-only profile
  // should not start on a mix preset whose white rows can never fill.
  function pickStartColor(state) {
    if (!state.scores) return 'mix';
    const red = hasAnyWine(state, 'red', []);
    const white = hasAnyWine(state, 'white', []);
    if (red && white) return 'mix';
    if (red) return 'red';
    if (white) return 'white';
    return 'mix';
  }

  // Build the preset by cascading love -> like -> adventure to fill the target,
  // grouped into rows by (type, level). This is where the cascade happens, so the
  // rows always mirror the exact-level wines the box will contain.
  function buildAllocatedRows(state, color, target) {
    if (!state.scores) return cloneRows(DEFAULT_ROWS[color] || DEFAULT_ROWS.mix);
    const want = target || 6;
    const types = color === 'red' || color === 'white' ? [color] : ['red', 'white'];
    const pool = [];
    const seen = new Set();
    types.forEach((wineType) => {
      ['love', 'like', 'adventure'].forEach((level) => {
        findMatches(state, { wineType, match: level }, [], []).forEach((product) => {
          if (seen.has(product.id)) return;
          seen.add(product.id);
          pool.push({ wineType, level, score: getMatchScore(state, product.id, level) });
        });
      });
    });
    // Closest first: love before like before adventure, then best score.
    pool.sort((a, b) => LEVEL_RANK[a.level] - LEVEL_RANK[b.level] || b.score - a.score);
    const chosen = pool.slice(0, want);

    const rows = [];
    const byKey = {};
    chosen.forEach((wine) => {
      const key = `${wine.wineType}|${wine.level}`;
      if (!byKey[key]) {
        byKey[key] = { wineType: wine.wineType, match: wine.level, quantity: 0 };
        rows.push(byKey[key]);
      }
      byKey[key].quantity += 1;
    });
    rows.sort((a, b) => a.wineType.localeCompare(b.wineType) || LEVEL_RANK[a.match] - LEVEL_RANK[b.match]);
    return rows.length ? rows : cloneRows(DEFAULT_ROWS[color] || DEFAULT_ROWS.mix);
  }

  function getMatchScore(state, productId, match) {
    const id = String(productId);
    const loveScore = state.scores?.love[id] || 0;
    const likeScore = state.scores?.like[id] || 0;

    if (match === 'love' && loveScore >= 94 && loveScore <= 100) return loveScore;
    if (match === 'like' && likeScore >= 84 && likeScore <= 100) return likeScore;
    if (match === 'like' && loveScore >= 88 && loveScore < 94) return loveScore;
    if (match === 'adventure' && ((loveScore >= 80 && loveScore < 88) || (likeScore >= 75 && likeScore < 84))) {
      return Math.max(loveScore, likeScore);
    }
    return null;
  }

  function matchesWineType(product, type) {
    const haystack = [product.wineColor, product.type, ...(product.tags || [])].join(' ').toLowerCase();
    if (type === 'red') return haystack.includes('red') || haystack.includes('rouge') || haystack.includes('rood') || haystack.includes('rode');
    if (type === 'white') return haystack.includes('white') || haystack.includes('blanc') || haystack.includes('wit');
    return true;
  }

  function renderPreferences(root, state) {
    const container = root.querySelector('[data-vp-preferences]');
    if (!container) return;
    const typeLabels = { red: t('redWine'), white: t('whiteWine') };
    const rowsHtml = state.rows.map((row, index) => {
      const lockedWineType = state.color === 'red' || state.color === 'white' ? state.color : '';
      // Only offer wine types that still have a usable wine once other rows have
      // taken theirs. If the row sits on a type with none left, move it.
      const wineTypes = availableWineTypes(state, index);
      const typesToShow = lockedWineType ? [lockedWineType] : (wineTypes.length ? wineTypes : ['red', 'white']);
      if (!typesToShow.includes(row.wineType)) row.wineType = typesToShow[0];

      // Same rule as the wine types: only levels that still have a wine are
      // offered, and a row sitting on a level with none moves to the closest one.
      const otherUsed = otherRowUsedIds(state, index);
      const availableMatches = ['love', 'like', 'adventure'].filter((value) => (
        !state.scores
        || findMatches(state, { wineType: row.wineType, match: value }, otherUsed, []).length > 0
      ));
      const matchesToShow = availableMatches.length ? availableMatches : ['love', 'like', 'adventure'];
      if (!matchesToShow.includes(row.match)) row.match = matchesToShow[0];

      const typeOptions = typesToShow
        .map((value) => `<option value="${value}"${row.wineType === value ? ' selected' : ''}>${typeLabels[value]}</option>`)
        .join('');
      const matchOptions = matchesToShow
        .map((value) => `<option value="${value}"${row.match === value ? ' selected' : ''}>${getMatchOptionLabel(value)}</option>`)
        .join('');

      // Cap the quantity to the wines this row can still ship (its type + cascade
      // level), accounting for what other rows already took, so no phantom slots.
      const rowMax = getRowMax(state, index, row);
      if (Number.isFinite(rowMax) && rowMax > 0) row.quantity = Math.min(Math.max(1, Number(row.quantity || 1)), rowMax);
      const maxAttr = Number.isFinite(rowMax) ? ` data-vp-row-max="${rowMax}"` : '';
      const plusDisabled = Number.isFinite(rowMax) && Number(row.quantity) >= rowMax ? ' disabled' : '';

      return `
      <div class="vp-smart-box-row" data-vp-row data-vp-match="${escapeAttr(row.match)}" data-vp-wine-type="${escapeAttr(row.wineType)}">
        <label>
          <span>${t('quantity')}</span>
          <span class="vp-smart-box-qty-control">
            <button type="button" data-vp-qty-minus aria-label="${escapeAttr(t('decreaseQuantity'))}">-</button>
            <input type="text" inputmode="numeric" value="${escapeAttr(row.quantity)}" data-vp-row-quantity${maxAttr} readonly>
            <button type="button" data-vp-qty-plus aria-label="${escapeAttr(t('increaseQuantity'))}"${plusDisabled}>+</button>
          </span>
        </label>
        <label>
          <span>${t('wineType')}</span>
          <select data-vp-row-type${lockedWineType ? ' disabled' : ''}>
            ${typeOptions}
          </select>
        </label>
        <label>
          <span>${t('loveQuestion')}</span>
          <select data-vp-row-match>
            ${matchOptions}
          </select>
        </label>
        ${state.rows.length > 1 ? `<button class="vp-smart-box-card-button" type="button" data-vp-remove-row>${t('remove')}</button>` : ''}
      </div>
    `;
    }).join('');

    // Specific wines the customer added appear as their own rows, after the auto
    // preference rows, each with its own quantity control and Remove button.
    const manualHtml = (state.manualRows || [])
      .map((manual, i) => renderManualRow(manual, state.rows.length + i))
      .join('');

    container.innerHTML = rowsHtml + manualHtml;

    container.querySelectorAll('input, select').forEach((input) => {
      input.addEventListener('change', () => {
        syncPreferenceRowAccent(input.closest('[data-vp-row]'));
        readPreferenceRows(root, state);
        state.selected = [];
        // generateBox re-fills the shared pool and re-renders the rows, so the
        // available types and quantity caps stay correct across every row.
        scheduleGenerate(root, state);
      });
    });

    bindQuantityControls(container, state);

    container.querySelectorAll('[data-vp-remove-row]').forEach((button) => {
      button.addEventListener('click', () => {
        const row = button.closest('[data-vp-row]');
        const index = Array.from(container.querySelectorAll('[data-vp-row]')).indexOf(row);
        if (index < 0) return;
        readPreferenceRows(root, state);
        readManualRows(root, state);
        state.selected = [];
        state.rows.splice(index, 1);
        renderPreferences(root, state);
        scheduleGenerate(root, state);
      });
    });

    container.querySelectorAll('[data-vp-remove-manual]').forEach((button) => {
      button.addEventListener('click', () => {
        const rowEl = button.closest('[data-vp-manual-row]');
        const id = String(rowEl?.getAttribute('data-vp-manual-id') || '');
        readPreferenceRows(root, state);
        readManualRows(root, state);
        state.manualRows = state.manualRows.filter((manual) => String(manual.productId) !== id);
        runManualAddButtonStateUpdate(root);
        generateBox(root, state);
      });
    });
  }

  // A manual wine as a table row: quantity control, the exact wine name (spanning
  // the type/level columns the auto rows use), and a Remove button.
  function renderManualRow(manual, index) {
    if (!manual || !manual.product) return '';
    const quantity = Math.max(1, Number(manual.quantity || 1));
    return `
      <div class="vp-smart-box-row vp-smart-box-row--manual" data-vp-manual-row data-vp-manual-id="${escapeAttr(manual.productId)}" data-vp-wine-type="${escapeAttr(manual.wineType)}">
        <label>
          <span>${t('quantity')}</span>
          <span class="vp-smart-box-qty-control">
            <button type="button" data-vp-qty-minus aria-label="${escapeAttr(t('decreaseQuantity'))}">-</button>
            <input type="text" inputmode="numeric" value="${escapeAttr(quantity)}" data-vp-manual-quantity readonly>
            <button type="button" data-vp-qty-plus aria-label="${escapeAttr(t('increaseQuantity'))}">+</button>
          </span>
        </label>
        <div class="vp-smart-box-manual-name">
          <span>${escapeHtml(getLabel('manual'))}</span>
          <strong>${escapeHtml(manual.product.title)}</strong>
        </div>
        <button class="vp-smart-box-card-button" type="button" data-vp-remove-manual>${t('remove')}</button>
      </div>
    `;
  }

  function scheduleGenerate(root, state, delay = 250) {
    window.clearTimeout(state.generateTimer);
    if (state.scores) setStatus(root, t('updating'), '');
    state.generateTimer = window.setTimeout(() => {
      readPreferenceRows(root, state);
      readManualRows(root, state);
      state.selected = [];
      generateBox(root, state);
    }, delay);
  }

  function readPreferenceRows(root, state) {
    state.rows = Array.from(root.querySelectorAll('[data-vp-row]')).map((row) => ({
      quantity: Math.max(1, Number(row.querySelector('[data-vp-row-quantity]')?.value || 1)),
      wineType: row.querySelector('[data-vp-row-type]')?.value || 'red',
      match: row.querySelector('[data-vp-row-match]')?.value || 'like'
    }));
  }

  function syncPreferenceRowAccent(row) {
    if (!row) return;
    const wineType = row.querySelector('[data-vp-row-type]')?.value || 'red';
    const match = row.querySelector('[data-vp-row-match]')?.value || 'like';
    row.setAttribute('data-vp-wine-type', wineType);
    row.setAttribute('data-vp-match', match);
  }

  function bindQuantityControls(scope, state, onChange) {
    scope.querySelectorAll('[data-vp-qty-minus], [data-vp-qty-plus]').forEach((button) => {
      if (button.dataset.vpQtyBound === 'true') return;
      button.dataset.vpQtyBound = 'true';
      button.addEventListener('click', () => {
        const control = button.closest('.vp-smart-box-qty-control');
        const input = control?.querySelector('input');
        if (!input) return;

        const current = Math.max(1, Number(input.value || 1));
        const max = Number(input.getAttribute('data-vp-row-max')) || Infinity;
        const next = button.hasAttribute('data-vp-qty-minus')
          ? Math.max(1, current - 1)
          : Math.min(max, current + 1);
        if (next === current) return;
        input.value = String(next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
        if (typeof onChange === 'function') onChange();
      });
    });
  }

  function renderSelected(root, state) {
    const grid = root.querySelector('[data-vp-selected-wines]');
    if (!grid) return;

    if (!state.selected.length) {
      grid.innerHTML = `<p class="vp-smart-box-card-reason">${t('generatedPlaceholder')}</p>`;
      return;
    }

    grid.innerHTML = state.selected.map((item, index) => {
      const product = item.product;
      const styleMeta = [formatWineType(product, item.wineType), product.region || product.grape].filter(Boolean).join(' · ');
      const countryMeta = product.country ? `${t('country')}: ${product.country}` : '';
      const productUrl = product.url || '#';
      const badge = item.badge || getLabel(item.label);
      return `
        <article class="vp-smart-box-card product-tile__container" data-vp-selected-index="${index}" data-vp-match="${escapeAttr(item.label)}">
          <a class="vp-smart-box-card-media product-tile__featured-media" href="${escapeAttr(productUrl)}">
            ${product.image?.url ? `<img src="${escapeAttr(product.image.url)}" alt="${escapeAttr(product.image.alt || product.title)}" loading="lazy">` : '<div class="vp-smart-box-card-image-placeholder" aria-hidden="true"></div>'}
            <span class="vp-smart-box-floating-badge">${escapeHtml(badge)}</span>
          </a>
          <div class="vp-smart-box-card-body">
            <a href="${escapeAttr(productUrl)}">
              <h3 class="font-body text-base">${escapeHtml(product.title)}</h3>
            </a>
            <strong class="vp-smart-box-card-price">${formatMoney(product.price)}${item.quantity > 1 ? ` · x${item.quantity}` : ''}</strong>
            <p class="vp-smart-box-card-meta">${escapeHtml(styleMeta)}</p>
            ${countryMeta ? `<p class="vp-smart-box-card-meta">${escapeHtml(countryMeta)}</p>` : ''}
            <div class="vp-smart-box-recommendation-text">
              <strong>${escapeHtml(badge)}</strong>
              <span>${escapeHtml(item.reason)}</span>
            </div>
            ${renderCardActions(state, item)}
          </div>
        </article>
      `;
    }).join('');

    grid.querySelectorAll('[data-vp-replace-wine]').forEach((button) => {
      button.addEventListener('click', () => replaceWine(root, state, Number(button.closest('[data-vp-selected-index]').getAttribute('data-vp-selected-index'))));
    });

    grid.querySelectorAll('[data-vp-remove-wine]').forEach((button) => {
      button.addEventListener('click', () => {
        const index = Number(button.closest('[data-vp-selected-index]').getAttribute('data-vp-selected-index'));
        const item = state.selected[index];
        // Manual wines are backed by state.manualRows, so drop them there too or the
        // next rebuild would bring the wine straight back.
        if (item && item.label === 'manual') {
          state.manualRows = state.manualRows.filter((manual) => String(manual.productId) !== String(item.productId));
          runManualAddButtonStateUpdate(root);
        }
        state.selected.splice(index, 1);
        renderSelected(root, state);
        renderPreferences(root, state);
        updateSummary(root, state);
      });
    });
  }

  // Card buttons. Manually added wines get "Remove". Every recommended wine gets a
  // "Replace" button, always visible so the layout is consistent under every card.
  // When no other wine of the same type + level is free, the button is disabled and
  // a short note explains why, so the customer understands instead of rage-clicking.
  function renderCardActions(state, item) {
    if (item.actions === false) return '';

    if (item.label === 'manual') {
      return `<div class="vp-smart-box-card-actions"><button class="vp-smart-box-card-button" type="button" data-vp-remove-wine>${t('remove')}</button></div>`;
    }

    const canReplace = canReplaceItem(state, item);
    if (canReplace) {
      return `<div class="vp-smart-box-card-actions"><button class="vp-smart-box-card-button" type="button" data-vp-replace-wine>${t('replace')}</button></div>`;
    }

    return `<div class="vp-smart-box-card-actions">
        <button class="vp-smart-box-card-button" type="button" data-vp-replace-wine disabled aria-disabled="true" title="${escapeAttr(t('noAlternative'))}">${t('replace')}</button>
        <span class="vp-smart-box-card-note">${escapeHtml(t('noAlternative'))}</span>
      </div>`;
  }

  // Is there a spare wine of this item's exact type + level, not already in the box?
  function canReplaceItem(state, item) {
    if (!state.scores) return false;
    const usedIds = new Set(state.selected.map((selected) => String(selected.productId)));
    return findMatches(state, { wineType: item.wineType, match: item.label }, usedIds, []).length > 0;
  }

  // A (type, level) combination not on the table yet that still has a free wine,
  // so "Add a preference" always creates a distinct new row. Combinations already
  // shown are skipped: the table regroups by (type, level), so re-adding one would
  // only merge back. Closest level first, respecting the colour. Returns null when
  // every fillable combination is already on the table (the button then disables).
  function pickSpareRow(state) {
    if (!state.scores) return null;
    const usedIds = new Set(state.selected.map((selected) => String(selected.productId)));
    const types = state.color === 'red' || state.color === 'white' ? [state.color] : ['red', 'white'];
    const existing = new Set((state.rows || []).map((row) => `${row.wineType}|${row.match}`));
    for (const match of ['love', 'like', 'adventure']) {
      for (const wineType of types) {
        if (existing.has(`${wineType}|${match}`)) continue;
        if (findMatches(state, { wineType, match }, usedIds, []).length > 0) {
          return { wineType, match };
        }
      }
    }
    return null;
  }

  function updateAddRowButton(root, state) {
    const button = root.querySelector('[data-vp-add-row]');
    if (!button) return;
    // Use the same check the click handler uses (pickSpareRow), so the button is
    // enabled exactly when a click can actually add a bottle. hasSpareWines was
    // looser (it returned true with no scores loaded), which left the button
    // clickable while the click silently did nothing.
    const disabled = !pickSpareRow(state);
    button.disabled = disabled;
    button.setAttribute('aria-disabled', String(disabled));
  }

  function replaceWine(root, state, index) {
    const item = state.selected[index];
    if (!item) return;
    const usedIds = new Set(state.selected.map((selected) => selected.productId));
    usedIds.delete(item.productId);
    const matches = findMatches(state, {
      quantity: item.quantity,
      wineType: item.wineType,
      match: item.label
    }, usedIds, [item.productId]);

    if (!matches.length) {
      setStatus(root, t('missingPreference'), 'error');
      setAdjustHint(root, t('missingPreferenceHint'), 'error');
      return;
    }

    const product = matches[0];
    state.selected[index] = {
      ...item,
      key: `${product.id}-${Date.now()}`,
      productId: product.id,
      variantId: product.variantId,
      product
    };
    renderSelected(root, state);
    updateSummary(root, state);
    setStatus(root, '', '');
    setAdjustHint(root, '', '');
  }

  function addManualWine(root, state) {
    const input = root.querySelector('[data-vp-search-input]');
    const quantityInput = root.querySelector('[data-vp-search-quantity]');
    const quantity = Math.max(1, Number(quantityInput?.value || 1));
    const product = getExactManualProduct(state, input?.value || '');

    if (!product) {
      setStatus(root, t('chooseWineFirst'), 'error');
      return;
    }

    // In demo the search box is the seed picker: naming a wine rebuilds the whole
    // box around it rather than appending a bottle to a box that has no owner.
    if (getMode(root) === 'demo') {
      if (input) input.value = '';
      runManualAddButtonStateUpdate(root);
      seedDemoFromWine(root, state, product);
      return;
    }

    // Capture any pending edits in the table before we rebuild it.
    readPreferenceRows(root, state);
    readManualRows(root, state);

    const alreadyPicked = state.manualRows.find((manual) => String(manual.productId) === String(product.id));
    if (alreadyPicked) {
      setStatus(root, t('duplicateWine'), '');
      if (input) input.value = '';
      if (quantityInput) quantityInput.value = '1';
      runManualAddButtonStateUpdate(root);
      return;
    }

    // Store the specific wine as a manual row. generateBox appends it to the box
    // and renderPreferences shows it as a row at the end of the table.
    state.manualRows.push({
      productId: String(product.id),
      variantId: product.variantId,
      quantity,
      wineType: inferWineType(product),
      product
    });
    if (input) input.value = '';
    if (quantityInput) quantityInput.value = '1';
    setStatus(root, '', '');
    runManualAddButtonStateUpdate(root);
    generateBox(root, state);
  }

  // Read the quantities of the manual rows currently shown in the table back into
  // state.manualRows, so a +/- on a manual row is kept across the next rebuild.
  function readManualRows(root, state) {
    const rows = root.querySelectorAll('[data-vp-manual-row]');
    rows.forEach((rowEl) => {
      const id = String(rowEl.getAttribute('data-vp-manual-id') || '');
      const manual = state.manualRows.find((entry) => String(entry.productId) === id);
      if (!manual) return;
      const qty = Number(rowEl.querySelector('[data-vp-manual-quantity]')?.value || manual.quantity || 1);
      manual.quantity = Math.max(1, qty);
    });
  }

  async function addBoxToCart(root, state) {
    const buttons = root.querySelectorAll('[data-vp-add-cart]');
    // A Smart Box without a taste profile cannot be fulfilled as promised.
    if (getMode(root) !== 'member') {
      window.location.href = root.getAttribute('data-taste-kit-url') || root.getAttribute('data-login-url') || '/';
      return;
    }
    if (getBottleCount(state) < 3) {
      setStatus(root, t('minimumBottles'), 'error');
      return;
    }

    const items = state.selected.map((item) => ({
      id: item.variantId,
      quantity: item.quantity,
      properties: {
        _vinpop_box: 'Smart Wine Box',
        _selection_source: 'smart_box_builder',
        _match_label: getLabel(item.label)
      }
    }));

    try {
      buttons.forEach((button) => { button.disabled = true; });
      const cartAddUrl = (root.getAttribute('data-cart-add-url') || '/cart/add').replace(/\.js$/, '') + '.js';
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items })
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'cart_add_failed');

      document.body.dispatchEvent(new CustomEvent('shapes:cart:afteradditem', { bubbles: true, detail: { response: data, sourceId: root.id } }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      setStatus(root, t('addedToCart'), '');
      window.location.href = root.getAttribute('data-checkout-url') || '/checkout';
    } catch (error) {
      console.error('Smart Box cart add failed', error);
      window.location.href = root.getAttribute('data-cart-url') || '/cart';
    } finally {
      buttons.forEach((button) => { button.disabled = false; });
    }
  }

  function updateTabs(root, state) {
    root.querySelectorAll('[data-vp-color]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.getAttribute('data-vp-color') === state.color));
    });
  }

  function updateSummary(root, state) {
    const bottles = getBottleCount(state);
    const wineTotal = getWineTotal(state);
    const shipping = getShippingQuote(bottles);
    const deliveredTotal = wineTotal + shipping.priceCents;
    const ok = bottles >= 3;
    const totalText = `${bottles} ${bottles === 1 ? t('bottle') : t('bottles')} · ${ok ? formatMoney(deliveredTotal) : t('minimumRequired')}`;
    const inline = root.querySelector('[data-vp-total-inline]');
    const addButtons = root.querySelectorAll('[data-vp-add-cart]');
    const wineSubtotal = root.querySelector('[data-vp-wine-subtotal]');
    const shippingTotal = root.querySelector('[data-vp-shipping-total]');
    const deliveredTotalEl = root.querySelector('[data-vp-delivered-total]');
    const freeShippingNote = root.querySelector('[data-vp-free-shipping-note]');

    if (inline) inline.textContent = totalText;
    if (wineSubtotal) wineSubtotal.textContent = formatMoney(wineTotal);
    if (shippingTotal) shippingTotal.textContent = shipping.priceCents === 0 ? t('free') : formatMoney(shipping.priceCents);
    if (deliveredTotalEl) deliveredTotalEl.textContent = ok ? formatMoney(deliveredTotal) : t('minimumShort');
    if (freeShippingNote) freeShippingNote.textContent = getFreeShippingMessage(shipping.zone, bottles, shipping.priceCents);
    addButtons.forEach((addButton) => {
      addButton.disabled = !ok || state.loading;
      const surface = addButton.querySelector('.push-btn__surface');
      if (surface) surface.textContent = ok ? t('order') : `${t('addAtLeast')} ${3 - bottles} ${3 - bottles === 1 ? t('bottle') : t('bottles')}`;
    });
    updateAddRowButton(root, state);
  }

  function getBottleCount(state) {
    return state.selected.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
  }

  function getWineTotal(state) {
    return state.selected.reduce((sum, item) => sum + (item.product.price * item.quantity), 0);
  }

  // Mirrors the Shopify automatic discount "1st smart wine box free shipping":
  // customer segment number_of_orders = 1, minimum 3 items, Netherlands. The two rules
  // must stay identical, because a page that promises free delivery the checkout then
  // charges is the one mistake this page cannot afford.
  //
  // `ordersCount` is nil for a guest, so an unknown value never counts as eligible: worst
  // case the page quotes the paid rate and the checkout surprises the customer downwards.
  // Anonymous visitors are in demo mode here and cannot check out at all, so they see the
  // normal grid rather than an offer nothing would honour for them.
  // 2026-09-28 : la premiere Smart Box n'est plus livree gratuitement (remise supprimee,
  // confirme par Adrien). Garde pour ne pas toucher aux appels ; renvoie toujours false.
  function isSecondOrderFreeShipping(customer, bottleCount, threshold) {
    return false;
  }

  function getShippingQuote(bottleCount) {
    const config = window.VinpopShippingConfig || getFallbackShippingConfig();
    const customer = window.VinpopCustomerData || {};
    const zone = getShippingZone(config, customer.countryCode, customer.country) ||
      config.zones?.[config.defaultZone || 'NETHERLANDS'] ||
      getFallbackShippingConfig().zones.NETHERLANDS;
    const threshold = Number(config.firstOrderFreeShippingThreshold || 3);

    if (isSecondOrderFreeShipping(customer, bottleCount, threshold)) {
      return {
        priceCents: 0,
        note: `${t('freeFirstBox')} 🚚`,
        zone
      };
    }

    const rate = getShippingRate(zone, bottleCount);
    const priceCents = Math.round(Number(rate?.price || 0) * 100);
    const zoneName = getShippingZoneName(zone);
    const note = priceCents === 0
      ? `${t('freeShipping')} ${t('forText')} ${rate?.minBottles || bottleCount}+ ${t('bottles')} - ${t('fastDelivery')} 🚚`
      : `${zone.flag || ''} ${t('shippingTo')} ${zoneName}: ${formatMoney(priceCents)} ${t('forText')} ${bottleCount || 1} ${bottleCount === 1 ? t('bottle') : t('bottles')} - ${t('fastDelivery')} 🚚`;

    return { priceCents, note, zone };
  }

  function getFreeShippingMessage(zone, bottleCount, priceCents) {
    if (priceCents === 0) return t('freeShippingUnlocked');
    const freeRate = (zone?.rates || [])
      .filter((rate) => Number(rate?.price || 0) === 0)
      .sort((a, b) => Number(a.minBottles || 0) - Number(b.minBottles || 0))[0];
    if (!freeRate?.minBottles) return '';
    const remaining = Math.max(0, Number(freeRate.minBottles) - Number(bottleCount || 0));
    if (!remaining) return t('freeShippingUnlocked');
    return t('bottlesUntilFreeShipping')
      .replace('{count}', String(remaining))
      .replace('{unit}', remaining === 1 ? t('bottle') : t('bottles'));
  }

  function getFallbackShippingConfig() {
    return {
      defaultZone: 'NETHERLANDS',
      firstOrderFreeShippingThreshold: 3,
      zones: {
        NETHERLANDS: {
          name: 'Netherlands',
          flag: '🇳🇱',
          countries: ['NL', 'Netherlands', 'Nederland', 'BE', 'Belgium', 'België', 'Belgique'],
          rates: [
            // Copie des tarifs Shopify (voir assets/shipping-rates-config.js), 2026-09-28.
            { minBottles: 1, maxBottles: 3, price: 14.4 },
            { minBottles: 4, maxBottles: 5, price: 11.9 },
            { minBottles: 6, maxBottles: 7, price: 8.9 },
            { minBottles: 8, maxBottles: 9, price: 5.9 },
            { minBottles: 10, maxBottles: 11, price: 2.9 },
            { minBottles: 12, maxBottles: Infinity, price: 0 }
          ]
        }
      }
    };
  }

  function getShippingZone(config, countryCode, countryName) {
    if (!config || !config.zones) return null;
    return Object.values(config.zones).find((zone) => {
      const countries = zone.countries || [];
      return countries.includes(countryCode) || countries.includes(countryName);
    }) || null;
  }

  function getShippingRate(zone, bottleCount) {
    const count = Math.max(1, Number(bottleCount || 1));
    const rates = zone?.rates || [];
    const matchingRates = rates.filter((rate) => count >= rate.minBottles && count <= rate.maxBottles);
    return matchingRates.sort((first, second) => first.price - second.price)[0] || rates[rates.length - 1] || { price: 0, minBottles: count };
  }

  function getShippingZoneName(zone) {
    const lang = String(document.documentElement.lang || 'en').split('-')[0];
    if (zone.displayName) return zone.displayName[lang] || zone.displayName.en || zone.name || 'Netherlands';
    return zone.name || 'Netherlands';
  }

  function populateSearchOptions(root, catalog) {
    const datalist = root.querySelector('[data-vp-search-options]');
    if (!datalist) return;
    const sorted = catalog.slice().sort((a, b) => (
      Number(Boolean(b.purchased)) - Number(Boolean(a.purchased)) ||
      a.title.localeCompare(b.title)
    ));
    datalist.innerHTML = sorted.map((product) => `<option value="${escapeAttr(product.title)}"></option>`).join('');
  }

  function normalizeQuery(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getExactManualProduct(state, query) {
    const normalized = normalizeQuery(query);
    if (!normalized) return null;
    return state.catalog.find((item) => normalizeQuery(item.title) === normalized) || null;
  }

  function getPurchasedProductIds() {
    const raw = window.vinpopPurchasedProductIds;
    if (raw instanceof Set) return new Set(Array.from(raw).map(String));
    if (Array.isArray(raw)) return new Set(raw.map(String));
    return new Set();
  }

  function setStatus(root, message, state) {
    const status = root.querySelector('[data-vp-status]');
    if (!status) return;
    status.textContent = message || '';
    if (state) status.setAttribute('data-state', state);
    else status.removeAttribute('data-state');
  }

  function setAdjustHint(root, message, state) {
    const hint = root.querySelector('[data-vp-adjust-hint]');
    if (!hint) return;
    const content = String(message || '').trim();
    hint.textContent = content;
    hint.hidden = !content;
    if (state) hint.setAttribute('data-state', state);
    else hint.removeAttribute('data-state');
  }

  function runManualAddButtonStateUpdate(root) {
    if (typeof root.__vpUpdateManualAddButtonState === 'function') {
      root.__vpUpdateManualAddButtonState();
    }
  }

  function setMode(root, mode, reason) {
    root.setAttribute('data-vp-mode', mode);
    if (reason) root.setAttribute('data-vp-demo-reason', reason);
    else root.removeAttribute('data-vp-demo-reason');
  }

  function getMode(root) {
    return root.getAttribute('data-vp-mode') || 'member';
  }

  /*
   * Demo mode. Shown to visitors with no taste profile (anonymous, or an account
   * with zero ratings). The screen is the member screen: same colour tabs, same
   * taste-direction rows, same builder. Only the seed differs — instead of the
   * three wines a member blind-tasted, we seed the engine from one wine the
   * visitor names, and score every other wine by its lab distance to it. No
   * personal match is ever fabricated: the badges are wine-to-wine lab numbers.
   */
  function startDemo(root, state, reason) {
    setMode(root, 'demo', reason);
    setManualButtonLabel(root, t('demoRebuild'));
    seedDemo(root, state, pickSeedsForColor(state, state.color));
  }

  /*
   * Three seeds, spread across the catalog — the same shape as a real Test Kit,
   * and the same shape as a member with three rated wines. One seed is not enough:
   * its close neighbours all point back at the same handful of wines, so the "Love
   * it" rows (which need >= 94) come back empty and the box renders half full.
   * The mix follows DEFAULT_ROWS.mix, which asks for one red and five whites.
   */
  function pickSeedsForColor(state, color) {
    if (color === 'red' || color === 'white') return pickSeeds(state, color, 3);
    return [...pickSeeds(state, 'red', 1), ...pickSeeds(state, 'white', 2)];
  }

  function pickSeeds(state, wineType, count, exclude) {
    const excluded = new Set((exclude || []).map((product) => String(product.id)));
    const pool = state.catalog.filter((product) => (
      matchesWineType(product, wineType)
      && product.image?.url
      && !excluded.has(String(product.id))
    ));

    const picked = [];
    while (picked.length < count && pool.length) {
      picked.push(pool.splice(Math.floor(Math.random() * pool.length), 1)[0]);
    }
    return picked;
  }

  /* The visitor named a wine: rebuild around it, in its colour, with two more to widen the field. */
  function seedDemoFromWine(root, state, product) {
    const wineType = inferWineType(product);
    state.color = wineType;
    state.rows = cloneRows(DEFAULT_ROWS[wineType] || DEFAULT_ROWS.mix);
    renderPreferences(root, state);
    updateTabs(root, state);
    seedDemo(root, state, [product, ...pickSeeds(state, wineType, 2, [product])], product);
  }

  async function seedDemo(root, state, seeds, namedProduct) {
    const sources = (seeds || []).filter(Boolean);
    if (!sources.length) return;

    state.demoSeeds = sources;
    state.demoNamed = namedProduct || null;
    setStatus(root, t('demoMeasuring'), '');
    setDemoHeadline(root, t('demoMeasuring'));

    try {
      const responses = await Promise.all(sources.map(async (product) => {
        const response = await fetch(`${getApiBase()}/api/wines/getDistance`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: product.id })
        });
        if (!response.ok) throw new Error(await readErrorDetail(response));
        return { sourceId: String(product.id), sourceRating: 'love', rows: await response.json() };
      }));

      // Treat each seed exactly as a member's "loved" wine, then hand over to the
      // real scoring pipeline. Everything downstream behaves identically.
      state.loveIds = new Set(sources.map((product) => String(product.id)));
      state.likeIds = new Set();
      state.distanceRows = responses;
      state.scores = buildScores(state);
    } catch (error) {
      console.error('Smart Box demo seed failed', error);
      state.scores = null;
      state.selected = [];
      setDemoHeadline(root, '');
      renderSelected(root, state);
      updateSummary(root, state);
      setStatus(root, t('demoFailed'), 'error');
      return;
    }

    setDemoHeadline(root, namedProduct
      ? t('demoHeadlineNamed').replace('{wine}', namedProduct.title)
      : t('demoHeadlineDefault'));
    generateBox(root, state);
  }

  /*
   * The badge carries the same promise as the member screen. Under it we keep the
   * lab number the promise rests on, so nothing on the page is an unanchored claim
   * about a taste profile the visitor does not have yet.
   */
  function decorateDemoSelection(state) {
    const seeds = state.demoSeeds || [];
    const seedIds = new Set(seeds.map((product) => String(product.id)));

    state.selected.forEach((item) => {
      const score = state.scores?.love?.[String(item.productId)];

      if (seedIds.has(String(item.productId))) {
        item.reason = t('demoSeedReason');
        return;
      }

      const closest = findClosestSeed(state, item.productId, seeds);
      item.reason = closest && Number.isFinite(score)
        ? t('demoReason').replace('{score}', score).replace('{wine}', closest.title)
        : t('demoSeedReason');
    });
  }

  /*
   * Member reasons. For a real customer, every recommended wine is scored by its
   * lab distance to the wines they rated. We surface the closest of those rated
   * wines by name, so the card explains itself: "Because you loved Villa Loren."
   * If we cannot resolve the source wine's name, we fall back to the generic
   * reason for the level, so the card is never blank or half-written.
   */
  function decorateMemberSelection(state) {
    state.selected.forEach((item) => {
      if (item.label === 'manual') {
        item.reason = getReason('manual');
        return;
      }
      const source = findClosestSource(state, item.productId);
      if (source && source.title) {
        const key = source.rating === 'love' ? 'reasonBecauseLoved' : 'reasonBecauseLiked';
        item.reason = t(key).replace('{wine}', source.title);
      } else {
        item.reason = getReason(item.label);
      }
    });
  }

  // The rated wine (with its love/like rating) that explains why this wine is in
  // the box. Mirrors findClosestSeed but over the customer's real rated wines.
  // We collect every rated wine whose lab profile matched this recommendation and
  // prefer the closest one we can actually name, so an unnameable top match (e.g.
  // an unpublished blind-tasting bottle) does not force a generic reason when a
  // named match also exists.
  function findClosestSource(state, productId) {
    const matches = [];

    (state.distanceRows || []).forEach((entry) => {
      (entry.rows || []).forEach((row) => {
        if (String(getComparedProductId(row, entry.sourceId)) !== String(productId)) return;
        const score = 100 - Number(row.perceptive_distance ?? row.distance);
        if (!Number.isFinite(score)) return;
        matches.push({
          id: entry.sourceId,
          rating: entry.sourceRating,
          score,
          title: getWineTitleById(state, entry.sourceId)
        });
      });
    });

    if (!matches.length) return null;
    matches.sort((a, b) => b.score - a.score);

    if (window.__vpSmartBoxDebug) {
      console.log('[SmartBox] source lookup', String(productId), matches.map((m) => ({
        sourceId: m.id, rating: m.rating, score: Math.round(m.score), title: m.title || '(unknown)'
      })));
    }

    // Closest source we can name; otherwise the closest overall (title empty ->
    // caller falls back to the generic reason).
    return matches.find((match) => match.title) || matches[0];
  }

  // Best-effort name for a wine id: the Test Kit / blind-tasting title map first
  // (that is where rated source wines live), then a title from the ratings payload
  // if any, then the sellable catalog. Empty string when unknown (caller falls
  // back to a generic reason).
  function getWineTitleById(state, id) {
    const key = String(id);
    if (state.titleMap && state.titleMap[key]) return state.titleMap[key];
    if (state.ratingTitles && state.ratingTitles[key]) return state.ratingTitles[key];
    const inCatalog = state.catalog.find((product) => String(product.id) === key);
    return inCatalog ? inCatalog.title : '';
  }

  function findClosestSeed(state, productId, seeds) {
    let best = null;
    let bestScore = -1;

    seeds.forEach((seed) => {
      const entry = (state.distanceRows || []).find((row) => row.sourceId === String(seed.id));
      (entry?.rows || []).forEach((row) => {
        if (String(getComparedProductId(row, seed.id)) !== String(productId)) return;
        const score = 100 - Number(row.perceptive_distance ?? row.distance);
        if (Number.isFinite(score) && score > bestScore) {
          bestScore = score;
          best = seed;
        }
      });
    });
    return best;
  }

  function setDemoHeadline(root, text) {
    const headline = root.querySelector('[data-vp-demo-headline]');
    if (headline) headline.textContent = text || '';
  }

  function setManualButtonLabel(root, text) {
    const label = root.querySelector('[data-vp-add-manual-label]');
    if (label) label.textContent = text;
  }

  function getCustomerId(root) {
    const fromRoot = root.getAttribute('data-customer-id');
    const fromMeta = document.querySelector('meta[name="customer-id"]')?.getAttribute('content');
    return String(fromRoot || fromMeta || '').trim();
  }

  function getMetaContent(name) {
    const meta = document.querySelector(`meta[name="${name}"]`);
    return meta ? String(meta.getAttribute('content') || '').trim() : '';
  }

  function getApiBase() {
    return (getMetaContent('api-url') || 'https://api.vinpop.fr').replace(/\/+$/, '');
  }

  function buildVinpopAuthHeaders(customerId) {
    const timestamp = getMetaContent('friends-auth-timestamp');
    const signature = getMetaContent('friends-auth-signature');
    const headers = { 'Content-Type': 'application/json' };
    if (customerId && timestamp && signature) {
      headers['X-Customer-Id'] = String(customerId);
      headers['X-Timestamp'] = timestamp;
      headers['X-Signature'] = signature;
    }
    return headers;
  }

  async function readErrorDetail(response) {
    try {
      const text = await response.text();
      return text || `${response.status} ${response.statusText}`;
    } catch (error) {
      return `${response.status} ${response.statusText}`;
    }
  }

  function inferWineType(product) {
    return matchesWineType(product, 'white') ? 'white' : 'red';
  }

  function getLanguage() {
    return String(document.documentElement.lang || 'en').split('-')[0] === 'nl' ? 'nl' : 'en';
  }

  function t(key) {
    const lang = getLanguage();
    return COPY[lang]?.[key] || COPY.en[key] || key;
  }

  function getLabel(label) {
    const lang = getLanguage();
    return COPY[lang]?.labels?.[label] || COPY.en.labels[label] || label;
  }

  function getReason(label) {
    const lang = getLanguage();
    return COPY[lang]?.reasons?.[label] || COPY.en.reasons[label] || '';
  }

  function getMatchOptionLabel(label) {
    const icons = {
      love: '❤️',
      like: '👍',
      adventure: '🧭'
    };
    if (label === 'adventure') return `${icons.adventure} ${t('safeAdventure')}`;
    return `${icons[label] || ''} ${getLabel(label)}`.trim();
  }

  function formatWineType(product, fallback) {
    const color = String(product.wineColor || fallback || '').toLowerCase();
    if (color.includes('white') || color.includes('blanc') || color.includes('wit')) return t('whiteType');
    if (color.includes('red') || color.includes('rouge') || color.includes('rood') || color.includes('rode')) return t('redType');
    return product.wineColor || '';
  }

  function formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return `€${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[char]));
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/`/g, '&#96;');
  }
})();
